import { Citr } from "@/sergecych.uni3/Citr";

let c: Citr | undefined;

export function defaultCitr(): Citr {
  if (!c) c = new Citr();
  return c;
}
